module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.ee7b96fa.ttf";